module.exports = __webpack_public_path__ + "img/arrow_right.cf5a2ebb.png";